<ng-container [ngSwitch]="true">
  <admin-paragraph-section
    *ngSwitchCase="componentName === 'paragraph'"
    [(sectionData)]="sectionData"
  >
  </admin-paragraph-section>
  <admin-info-section
    *ngSwitchCase="componentName === 'info'"
    [(sectionData)]="sectionData"
  >
  </admin-info-section>
  <admin-picture-section
    *ngSwitchCase="componentName === 'picture'"
    [(sectionData)]="sectionData"
  >
  </admin-picture-section>
  <admin-title-section
    [(sectionData)]="sectionData"
    [componentName]="componentName"
    *ngSwitchCase="
      componentName === 'main-title' ||
      componentName === 'secondary-title' ||
      componentName === 'third-title'
    "
  >
  </admin-title-section>
  <admin-instagram-section
    *ngSwitchCase="componentName === 'instagram'"
    [(sectionData)]="sectionData"
  ></admin-instagram-section>
  <admin-mention-section
    *ngSwitchCase="componentName === 'mention'"
    [(sectionData)]="sectionData"
  ></admin-mention-section>
  <admin-article-link-section
    *ngSwitchCase="componentName === 'articleLink'"
    [(sectionData)]="sectionData"
  ></admin-article-link-section>
  <admin-iframe-section
    *ngSwitchCase="componentName === 'iframe'"
    [(sectionData)]="sectionData"
  ></admin-iframe-section>
  <admin-button-section
    *ngSwitchCase="componentName === 'button'"
    [(sectionData)]="sectionData"
  ></admin-button-section>
</ng-container>
